/**
 * Scroll to Top & WhatsApp Button
 * Shows buttons when user scrolls down
 */

class FloatingButtons {
  constructor() {
    this.scrollButton = null;
    this.whatsappButton = null;
    this.scrollThreshold = 300;
    this.init();
  }

  init() {
    this.createButtons();
    this.attachEvents();
    this.handleScroll();
  }

  createButtons() {
    // Create scroll to top button
    this.scrollButton = document.createElement('button');
    this.scrollButton.className = 'scroll-to-top';
    this.scrollButton.setAttribute('aria-label', 'Yukarı Çık');
    this.scrollButton.innerHTML = `
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 19V5M12 5L5 12M12 5L19 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `;
    document.body.appendChild(this.scrollButton);

    // Create WhatsApp button
    const whatsappNumber = window.themeSettings?.whatsapp_number || '+905557200553';
    const whatsappMessage = encodeURIComponent(window.themeSettings?.whatsapp_message || 'Merhaba, ürünleriniz hakkında bilgi almak istiyorum.');
    
    this.whatsappButton = document.createElement('a');
    this.whatsappButton.className = 'whatsapp-button';
    this.whatsappButton.href = `https://wa.me/${whatsappNumber.replace(/[^0-9]/g, '')}?text=${whatsappMessage}`;
    this.whatsappButton.target = '_blank';
    this.whatsappButton.rel = 'noopener noreferrer';
    this.whatsappButton.setAttribute('aria-label', 'WhatsApp ile İletişim');
    this.whatsappButton.innerHTML = `
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" fill="currentColor"/>
        <path d="M12 0C5.373 0 0 5.373 0 12c0 2.625.846 5.059 2.284 7.034L.789 23.456l4.566-1.487A11.947 11.947 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-2.186 0-4.236-.705-5.896-1.903l-.423-.273-3.165 1.03 1.053-3.048-.299-.437A9.955 9.955 0 012 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z" fill="currentColor"/>
      </svg>
    `;
    document.body.appendChild(this.whatsappButton);
  }

  attachEvents() {
    let ticking = false;
    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          this.handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    });

    this.scrollButton.addEventListener('click', () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
  }

  handleScroll() {
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    
    if (scrollPosition > this.scrollThreshold) {
      this.scrollButton.classList.add('scroll-to-top--visible');
      this.whatsappButton.classList.add('whatsapp-button--visible');
    } else {
      this.scrollButton.classList.remove('scroll-to-top--visible');
      this.whatsappButton.classList.remove('whatsapp-button--visible');
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new FloatingButtons();
  });
} else {
  new FloatingButtons();
}
